// extracted by mini-css-extract-plugin
module.exports = {"message":"Ticket_message__a-i6l","attachmentsContainer":"Ticket_attachmentsContainer__Q52cy","attachment":"Ticket_attachment__IUkH9"};